{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-510000",
  "sheetId": "StatementOfCashFlowsDirectMethod",
  "label": "[510000] Statement of cash flows, direct method",
  "description": "Statement of cash flows using direct method showing gross cash receipts and payments",
  "controls": [
    {
      "qname": "ssmt:StatementOfCashFlowsHeader",
      "label": "STATEMENT OF CASH FLOWS",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ssmt:CashFlowsFromOperatingActivitiesHeader",
      "label": "CASH FLOWS FROM OPERATING ACTIVITIES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt:CashReceiptsFromCustomers",
      "label": "Cash receipts from customers",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:CashPaidToSuppliersAndEmployees",
      "label": "Cash paid to suppliers and employees",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:CashGeneratedFromOperations",
      "label": "Cash generated from operations",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:InterestPaid",
      "label": "Interest paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:IncomeTaxesPaid",
      "label": "Income taxes paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:InterestReceived",
      "label": "Interest received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:DividendsReceived",
      "label": "Dividends received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:NetCashFromOperatingActivities",
      "label": "Net cash from operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:CashFlowsFromInvestingActivitiesHeader",
      "label": "CASH FLOWS FROM INVESTING ACTIVITIES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt:PurchaseOfPropertyPlantAndEquipment",
      "label": "Purchase of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ProceedsFromDisposalOfPropertyPlantAndEquipment",
      "label": "Proceeds from disposal of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:PurchaseOfIntangibleAssets",
      "label": "Purchase of intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:PurchaseOfInvestments",
      "label": "Purchase of investments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ProceedsFromDisposalOfInvestments",
      "label": "Proceeds from disposal of investments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:AcquisitionOfSubsidiaries",
      "label": "Acquisition of subsidiaries, net of cash acquired",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:NetCashUsedInInvestingActivities",
      "label": "Net cash used in investing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:CashFlowsFromFinancingActivitiesHeader",
      "label": "CASH FLOWS FROM FINANCING ACTIVITIES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt:ProceedsFromIssuanceOfShareCapital",
      "label": "Proceeds from issuance of share capital",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ProceedsFromBorrowings",
      "label": "Proceeds from borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:RepaymentOfBorrowings",
      "label": "Repayment of borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:PaymentOfLeaseLiabilities",
      "label": "Payment of lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:DividendsPaid",
      "label": "Dividends paid",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:DividendsPaidToNonControllingInterests",
      "label": "Dividends paid to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:NetCashFromFinancingActivities",
      "label": "Net cash from/(used in) financing activities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:NetIncreaseDecreaseInCashAndCashEquivalents",
      "label": "Net increase/(decrease) in cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:CashAndCashEquivalentsAtBeginningOfYear",
      "label": "Cash and cash equivalents at beginning of year",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:EffectOfExchangeRateChanges",
      "label": "Effect of exchange rate changes on cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:CashAndCashEquivalentsAtEndOfYear",
      "label": "Cash and cash equivalents at end of year",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "note": "Should match cash balance on statement of financial position"
      }
    }
  ]
}
